import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

// What needs someone today, from our own database - fast, and separate from
// the Books and CRM figures the page fetches on its own.
export const getDashboard = async () => (await axios.get(`${process.env.REACT_APP_API_HOST}/${apiConstants.DASHBOARD}`)).data;
